module.exports = __webpack_public_path__ + "static/media/footer_2.ef9fd4bd.png";